<template>
  <v-app v-if="isMobileBrowser">
    <v-content>
      <v-container fluid class="parent-container" :class="{'platform-ios':$root.platform === 'ios'}">  
        <!-- componenets will load inside router view -->
        <!-- <keep-alive include="report_list">
          <transition name="fade" mode="out-in">
            <router-view :key="$route.fullPath"></router-view>
          </transition>
        </keep-alive> -->
        <!-- <keep-alive include="ledger_items"> -->
          <router-view :key="$route.fullPath"></router-view>
        <!-- </keep-alive> -->
      </v-container>
    </v-content>

    <!-- <v-snackbar multi-line class="pl-0" :value="snackbar" :timeout="0">
      You have {{unreadTicketCount}} unread {{unreadTicketCount==1 ? 'ticket' : 'tickets'}}
      <v-btn flat class="pr-0" color="warning" @click.native="snackbar=false">Later</v-btn>
      <v-btn flat class="pr-0" color="primary" @click.native="fn_openSupportView">View</v-btn>
    </v-snackbar> -->

    <v-snackbar multi-line class="pl-0" :value="snackbar_change_drive" :timeout="0">
      Please update your backup drive to {{dataDriveToSelect}}
      <v-btn flat class="pr-0" color="warning" @click.native="snackbar_change_drive=false">Later</v-btn>
      <v-btn flat class="pr-0" color="primary" @click.native="fn_openDialogToChangeDrive">Update</v-btn>
    </v-snackbar>

    <v-snackbar multi-line class="pl-0 snackbar-extra-large" :value="snackbar_alert" :timeout="0">
      {{snackbar_alert_msg}}
      <v-btn flat class="pr-0" color="primary" @click.native="snackbar_alert=false">Close</v-btn>
      <v-btn flat class="pr-0" color="primary" @click.native="fn_changeDrive">Change</v-btn>
    </v-snackbar>

    <v-snackbar multi-line class="pl-0" :value="snackbar_sync_alert" :timeout="0">
      {{syncItemCount}} unsync {{syncItemCount == 1 ? 'record' : 'records'}}
      <v-btn flat class="pr-0" color="primary" @click.native="snackbar_sync_alert=false">Close</v-btn>
      <v-btn flat class="pr-0" color="primary" @click.native="fn_syncItems">Sync Now</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialog_sync_alert" persistent max-width="290">
      <v-card>
        <v-card-text>{{syncItemCount}} unsync {{syncItemCount == 1 ? 'record' : 'records'}}</v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="fn_closeDialogSyncAlert">Close</v-btn>
        <v-btn color="primary" flat @click.native="fn_syncItems">Sync Now</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_unread_ticket" persistent max-width="290">
      <v-card>
        <v-card-text>You have {{unreadTicketCount}} unread {{unreadTicketCount==1 ? 'ticket' : 'tickets'}}</v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="fn_closeDialogUnreadTicket">Close</v-btn>
        <v-btn color="primary" flat @click.native="fn_openSupportView">View Now</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_alert" persistent max-width="290">
      <v-card style="border-radius: 5px;">
        <v-card-title class="title noshadow">{{ alertDataObj.title }}</v-card-title>
        <v-card-text class="pt-0">
          <div v-html="alertDataObj.description"></div>
        </v-card-text>
        <v-card-actions>
          <v-layout col wrap v-if="alertDataObj.hasThreeBtns">
            <v-flex xs12 sm12 md12 center-align>
              <v-btn color="primary" flat @click.native="alertDataObj.actionMethod">{{ alertDataObj.okBtnText }}</v-btn>
            </v-flex>
            <v-flex xs12 sm12 md12 mt-1 center-align>
              <v-btn color="primary" flat @click.native="alertDataObj.closeDialog">{{ alertDataObj.cancelBtnText }}</v-btn>
            </v-flex>
            <v-flex xs12 sm12 md12 mt-1 center-align v-if="alertDataObj.hasThreeBtns">
              <v-btn color="red" flat @click.native="alertDataObj.thirdBtnAction">{{ alertDataObj.thirdBtnText }}</v-btn>    
            </v-flex>
          </v-layout>

          <v-layout row wrap v-else>
            <v-flex xs6 sm6 md6 center-align style="border-right: 1px #ddd solid;">
              <v-btn color="primary" flat @click.native="alertDataObj.closeDialog">{{ alertDataObj.cancelBtnText }}</v-btn>
            </v-flex>
            <v-flex xs6 sm6 md6 center-align>
              <v-btn color="primary" flat @click.native="alertDataObj.actionMethod">{{ alertDataObj.okBtnText }}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_permission" persistent max-width="290">
	      <v-card>
	        <v-card-text>
	        	<div v-if="$root.permissionType=='contact'">
	          		Allow Bizops App to access your contacts.
	          	</div>
	          	<div v-if="$root.permissionType=='storage'">
	          		Allow Bizops App to access your device's storage, photos, media and files.
	          	</div>
				      <div v-if="$root.permissionType=='camera'">
	          		Allow Bizops App to access your device's camera.
	          	</div>
              <div v-if="$root.permissionType=='nearbydevice'">
	          		Allow Bizops App to scan Nearby devices.
	          	</div>
	        </v-card-text>
	        <v-card-actions>
	        	<v-spacer></v-spacer>
            <v-btn small color="blue darken-1" flat @click="fn_closeDialogPermission">close</v-btn>
            <v-btn small color="blue darken-1" flat @click.native="fn_goToSettings">Ok</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>

      <v-dialog v-model="dialog_android_update" v-if="dialog_android_update" persistent max-width="290">
	      <v-card flat>
          <v-card-title font-medium primary-title noshadow>
            App Update Available
          </v-card-title>
          <v-divider></v-divider>
	        <v-card-text>
	        	To use this feature update your BizOps App from <span font-medium>Google Play</span>.
	        </v-card-text>
	        <v-card-actions>
	        	<v-spacer></v-spacer>
            <v-btn small color="blue darken-1" flat @click="fn_closeAppUpdateDialog">Later</v-btn>
            <v-btn small color="blue darken-1" flat @click.native="fn_openPlayStore">Update Now</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>

      <v-dialog v-model="dialog_client_connection" v-if="dialog_client_connection" persistent max-width="290">
      <v-card style="border-radius: 5px;">
        <v-card-title class="title">
          <template v-if="$root.clientConnectionStatus != 'Failed'">
            Connecting...
          </template>
          <template v-else>Connection interrupted!</template>
        </v-card-title>
        <v-card-text white-background>
          <v-layout ma-0 row wrap>

              <v-flex xs12 sm12 md12 pa-3 center-align pt-0 light-opacity-color>
                <p>{{fn_getClientBusinessName()}}</p>
              </v-flex>

              <template v-if="$root.clientConnectionStatus != 'Failed'">
                
                <v-flex xs12 sm12 md12 v-if="$root.connectionNumber">
                  <p>Connection ID: {{ $root.connectionNumber }}</p>
                </v-flex>

                <v-flex xs2 sm2 md2 center-align>
                  <v-icon>phone_android</v-icon>
                </v-flex>

                <v-flex xs8 sm8 md8 style="display: flex;align-items: center;">
                  <v-progress-linear color="primary" indeterminate :height="5" class="ma-0"></v-progress-linear>
                </v-flex>

                <v-flex xs2 sm2 md2 center-align>
                  <v-icon>phone_android</v-icon>
                </v-flex>
              </template>

            </v-layout>
        </v-card-text>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.native="fn_disconnect">Cancel</v-btn>
          <v-btn color="primary" :disabled="$root.clientConnectionStatus != 'Failed'" flat @click.native="$root.fn_connectWithClientBusiness(null)">Reconnect</v-btn>
        </v-card-actions> -->
        <v-card-actions class="pa-3 white-background">
            <v-layout ma-0 row wrap>
              <v-flex xs12 sm12 md12 center-align>
                <v-btn color="primary" block :disabled="$root.clientConnectionStatus != 'Failed'" @click="$root.fn_connectWithClientBusiness(null)"><v-icon class="mr-2" style="color: #fff !important;" font20 left>sync</v-icon>Reconnect</v-btn>
              </v-flex>

              <v-flex xs12 sm12 md12 center-align mt-3>
                <v-btn color="primary" outline block text @click="fn_disconnect">Cancel</v-btn>
              </v-flex>
            </v-layout>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <dialog-data-backup ref="ref_dialogDataBackup" :skipAlert="fn_closeDataBackupDialog" :appOpenCount="appOpenCount"></dialog-data-backup>
    <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :okBtnText="okBtnText" :cancelBtnText="cancelBtnText" :actionMethod="actionMethod" :cancelMethod="cancelMethod" :largeButtons="true"></dialog-confirmation>
    
  </v-app>
</template>

<script>

import dialogBackupAlert from './components/dialogs/dialog_data_backup'
import dialogConfirmation from './components/dialogs/dialog_confirmation'

  export default{
    data(){
      return{
        // snackbar:false,
        unreadTicketCount:null,
        unreadTicketID:null,
        dataDriveToSelect:null,
        snackbar_change_drive:false,
        snackbar_alert:false,
        snackbar_alert_msg:null,
        snackbar_sync_alert:false,
        syncItemCount:null,
        dialog_sync_alert:false,
        dialog_unread_ticket:false,
        isMobileBrowser:false,
        dialog_alert:false,
        alertDataObj:{'title':null, 'description':null, 'okBtnText':'Ok', 'cancelBtnText':'cancel', 'hasThreeBtns':false, 'thirdBtnText':null},
        dialog_permission:false,
        dialog_android_update:false,
        dialog_client_connection:false,
        doubleBackPress:0,
        appOpenCount:0,

        confirmationHeader:null,
        confirmationMessage:null,
        actionMethod:null,
        cancelBtnText:null,
        cancelMethod:null,
        okBtnText:null
      }
    },
    components:{
      'dialog-data-backup':dialogBackupAlert,
      'dialog-confirmation':dialogConfirmation
    },
    methods:{
      fn_changeDrive: function(){
        this.snackbar_alert = false;
        this.$router.push({"path":"/settings/backup", query:{"changedrive":1}});
      },

      fn_openSupportView: function(){
        // this.snackbar = false;
        this.fn_closeDialogUnreadTicket();
        this.$root.fn_openSupport('customer', this.unreadTicketCount, this.unreadTicketID);
      },

      fn_openDialogToChangeDrive: function(){
        this.snackbar_change_drive = false;
        this.$root.fn_openDialogChangeDrive();
      },

      fn_syncItems: function(){
        this.fn_closeDialogSyncAlert();
        this.snackbar_sync_alert = false;
        this.$router.push({"path":"/settings", query:{"sync":1}});
      },

      fn_closeDialogSyncAlert: function(){
        this.dialog_sync_alert = false;
        window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
      },

      fn_closeDialogUnreadTicket: function(){
        this.dialog_unread_ticket = false;
        window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
      },

      fn_closeDialogAlert: function(){
        this.dialog_alert = false;
        window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
      },

      fn_closeDialogPermission: function(){
        this.dialog_permission = false;
        window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
      },

      fn_doNotAskAgain: function(){
        localStorage.setItem('donotaskfornotification', 1);
        this.fn_closeDialogAlert();
      },

      fn_goToSettings: function(){
        this.fn_closeDialogPermission();
        this.fn_closeDialogAlert();
        // sending storage just for the test change this later
        // this.$root.permissionType = 'storage';
        this.$root.fn_gotoPermissionSettings();
      },

      fn_closeAppUpdateDialog: function(){
        this.dialog_android_update = false;
        window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
      },

      fn_openPlayStore: function(){
        this.fn_closeAppUpdateDialog();
        this.getData("OpenPlayStore", null, 
            {
                onSuccess: function(response){
                    console.log(response);
                }, 
                onError: function(error){
                    console.log(error);
                }
            }
        );
      },

      fn_disconnect: function(){
        if(this.$root.clientConnectionStatus != "Failed"){
          this.doubleBackPress++;
          console.log(this.doubleBackPress);
          setTimeout(() => {
            this.doubleBackPress = 0;
          }, 4000);
          if(this.doubleBackPress === 1){
            this.showToast("Press again to abort connection request");
          }
          if(this.doubleBackPress === 2){
            this.dialog_client_connection = false;
            this.$root.fn_disconnectClientConnection();
          }
        }
        else{
          this.dialog_client_connection = false;
          this.$root.fn_disconnectClientConnection();
        }
      },

      fn_getClientBusinessName: function(){
        if(localStorage.getItem("recentBusinessObj")){
          let businessObj = JSON.parse(localStorage.getItem("recentBusinessObj"));
          return businessObj.clientBusinessName;
        }
        else{
          return null;
        }
      },

      fn_gotoDriveSetup: function(){
        this.fn_closeDialogAlert();
        this.$router.push({path:"/registration/business/setupdrive"});
      },

      fn_closeDataBackupDialog: function(){
        // let routeName = this.$route.name;
        // if(routeName == 'reports' || routeName == 'activitytabs' || routeName == 'actions' || routeName == 'settings'){
        //   this.fn_showBottomNavigation();
        // }

        this.$refs['ref_dialogDataBackup'].closeDialogWeb();
        window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
        this.fn_openDialogConfirmation();
        
        // if(this.appOpenCount && this.appOpenCount > 4){
        //   this.exitApp();
        // }
        // else{
        //   this.$refs['ref_dialogDataBackup'].closeDialogWeb();
        //   window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
        //   this.fn_openDialogConfirmation();
        // }
      },

      fn_openDialogConfirmation: function(){
        let daysDiffInMs = new Date() - new Date(this.$root.CurrentBusiness.CreatedOn);
        let diffInDays = Math.floor(daysDiffInMs / (1000 * 60 * 60 * 24));

        window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
        window.js_globals.fn_onBackPress = this.fn_closeDialogConfirmation;
        this.confirmationHeader = "Skip Data Backup?";
        this.confirmationMessage = "<div class='pl-3 pr-3 pt-2 pb-2 mb-2' style='background:#fff3cd;color:#856404;margin:0px -16px;'><p class='mb-1 font16 font-medium'>Warning: You could lose your data, if you didn’t backup.</p></div><p class='mb-1 font16'>Are you sure you want to skip auto data backup?</p>"
        this.okBtnText = 'Backup Now';
        this.cancelBtnText = this.appOpenCount > 4 && diffInDays > 14 ? 'contact support' : 'Skip anyway';
        this.cancelMethod = this.appOpenCount > 4 && diffInDays > 14 ? this.$root.fn_whatsAppSupport  : this.fn_closeDialogConfirmation;
        this.actionMethod = this.fn_gotoDataBackup;
        this.$refs['ref_dialogConfirmation'].openDialogWeb();
      },

      fn_gotoDataBackup: function(){
        this.fn_closeDialogConfirmation(1);
        this.$router.push({path:"/settings/backup", query:{"auto_start":1, exitapp:1}});
      },

      fn_closeDialogConfirmation: function(tobackup){
        // checking how many days ago business created in days
        let daysDiffInMs = new Date() - new Date(this.$root.CurrentBusiness.CreatedOn);
        let diffInDays = Math.floor(daysDiffInMs / (1000 * 60 * 60 * 24));

        // cancelling backup if
        // diffInDays > 14
        
        if(diffInDays <= 14 || !this.appOpenCount || (this.appOpenCount && this.appOpenCount <= 4) || tobackup){

          let routeName = this.$route.name;
          if(routeName == 'reports' || routeName == 'activitytabs' || routeName == 'actions' || routeName == 'settings'){
            this.fn_showBottomNavigation();
          }

          this.$refs['ref_dialogConfirmation'].closeDialogWeb();
          window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
        }
      },

      fn_showBottomNavigation: function () {
        let self = this;
        let routeName = this.$route.name;
        let index = null;
        if(routeName == 'reports')
          index = 1001;
        else if(routeName == 'activitytabs')
          index = 1002;
        else if(routeName == 'actions')
          index = 1003;
        else if(routeName == 'settings')
          index = 1004;

        let navigationObject = {activeIndex: index};
        this.showBottomNavigation(null, navigationObject, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
            // onChange: null, 
            onMenuItemClick: function (tagId, menuId, menuAction) {
              self.$root.fn_bottomNavigationItemClick(tagId, menuId, menuAction)
            }
          }
        );
      },

      fn_hideBottomNavigation: function () {
        this.hideBottomNavigation({
            onSuccess: function(response){
                console.log(response);
            }, 
            onError: function(error){
                console.log(error);
            }
        });
      },
    },
    mounted: function(){
      let self = this;
      this.$eventHub.$on('ShowNotificationBar', ticketObject => {
        console.log(ticketObject);
        if(ticketObject && ticketObject.ticketCount){
          this.unreadTicketCount = ticketObject.ticketCount;
          this.unreadTicketID = ticketObject.supportTicketID;
          // this.snackbar = true;
          window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
          window.js_globals.fn_onBackPress = this.fn_closeDialogUnreadTicket;
          this.dialog_unread_ticket = true;
        }
      });

      this.$eventHub.$on('ShowChangeDriveAlert', dataDriveObject => {
        console.log(dataDriveObject);
        if(dataDriveObject && dataDriveObject.dataDriveToSelect){
          this.dataDriveToSelect = dataDriveObject.dataDriveToSelect;
          this.snackbar_change_drive = true;
        }
      });

      this.$eventHub.$on('ShowDialogAlert', alertObject => {
        console.log(alertObject);
        if(alertObject){
            if(alertObject.requireSize){
                this.snackbar_alert_msg = "Minimum "+alertObject.requireSize+" is required. Please clean up or change your Google Drive!"    
            }
            else{
                this.snackbar_alert_msg = "Google Drive is full. Please clean up or change your Google Drive!"
            }
            this.snackbar_alert = true;
        }
      });

      this.$eventHub.$on('ShowSyncAlert', alertObject => {
        console.log(alertObject);
        if(alertObject && alertObject.count){
          this.syncItemCount = alertObject.count;
          // this.snackbar_sync_alert = true;
          window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
          window.js_globals.fn_onBackPress = this.fn_closeDialogSyncAlert;
          this.dialog_sync_alert = true;
        }
      });

      this.$eventHub.$on('ShowAlert', alertObject => {
        console.log(alertObject);
        let showAlert = true;
        if(alertObject && alertObject.type && alertObject.type == 'notification'){
          this.alertDataObj.title = "Notification Permission";
          // this.alertDataObj.description = "Allow notification permission to access the BizOps App on a desktop and receive additional alerts and messages.";
          this.alertDataObj.description = "<div class='font-medium light-opacity-color'><p class='mb-1'>Please allow notification permission for:</p><p class='mb-1'>- Auto Data Backup Service</p><p class='mb-1'>- Access BizOps App on Desktop</p>";
          this.alertDataObj.okBtnText = "Allow";
          this.alertDataObj.cancelBtnText = "Don't Allow"
          this.alertDataObj.hasThreeBtns = false;
          this.alertDataObj.thirdBtnText = "Don't ask again"
          this.alertDataObj.actionMethod = this.fn_goToSettings;
          this.alertDataObj.closeDialog = this.fn_closeDialogAlert;
          this.alertDataObj.thirdBtnAction = this.fn_doNotAskAgain;
          this.$root.permissionType = "notification";
          if(localStorage.getItem('donotaskfornotification')){
            showAlert = false;
          }
        }
        else if(alertObject && alertObject.type && alertObject.type == 'drive_logout'){
          this.alertDataObj.title = "Drive Logged Out";
          this.alertDataObj.description = "Your Google Data Drive has been logged out from BizOps App.<br><br>Sign In to backup your data.";
          this.alertDataObj.okBtnText = "Okay";
          this.alertDataObj.cancelBtnText = "Cancel"
          this.alertDataObj.hasThreeBtns = false;
          this.alertDataObj.actionMethod = this.fn_gotoDriveSetup;
          this.alertDataObj.closeDialog = this.fn_closeDialogAlert;
        }

        if(showAlert){
          window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
          window.js_globals.fn_onBackPress = this.fn_closeDialogAlert;
          this.dialog_alert = true;
        }
      });

      let called = false;
      this.$eventHub.$on('PermissionDialog', () => {
        if(!called){
          called = true;
          window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
          window.js_globals.fn_onBackPress = this.fn_closeDialogPermission;
          this.dialog_permission = true;
        }

        setTimeout(() => {
          called = false;
        }, 1000);
      });

      this.$eventHub.$on('AppUpdateDialog', () => {
        if(!called){
          called = true;
          window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
          window.js_globals.fn_onBackPress = this.fn_closeAppUpdateDialog;
          this.dialog_android_update = true;
        }
        
        setTimeout(() => {
          called = false;
        }, 1000);
      });

      this.$eventHub.$on('alertTest', alertObject => {
        console.log(alertObject);
        window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
        window.js_globals.fn_onBackPress = this.fn_closeDialogSyncAlert;
        this.dialog_sync_alert = true;
      });

      this.$eventHub.$on('ClientConnectionStatus', () => {
        if(!called){
          if(this.$root.clientConnectionStatus != 'Connected'){
            if(!this.dialog_client_connection){
              // this.$router.push({path:'/webrtcconnectionview'});
              // assigning onbackpress fn to temp on backpress
              window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
              // assigning fn_disconnect to on backpress
              window.js_globals.fn_onBackPress = this.fn_disconnect;
              this.dialog_client_connection = true;
            }
          }
          else if(this.$root.clientConnectionStatus == 'Connected'){
            this.dialog_client_connection = false;
            // assigning temp on backpress fn back to on backpress
            window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
            let recentBusinessObj = JSON.parse(localStorage.getItem('recentBusinessObj'));
            this.$root.fn_closeLocalDB(recentBusinessObj.isNewConnection);
          }
        }

        setTimeout(() => {
          called = false;
        }, 1000);
      });

      this.$eventHub.$on('DataBackupDialog', dataObj => {
        if(!called){
          called = true;
          window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
          window.js_globals.fn_onBackPress = this.fn_closeDataBackupDialog;
          if(dataObj && dataObj.appOpenCount){
            this.appOpenCount = dataObj.appOpenCount;
          }

          let routeName = this.$route.name;

          console.log('route details');
          console.log(this.$route);
          if(routeName == 'reports' || routeName == 'activitytabs' || routeName == 'actions' || routeName == 'settings'){
            this.fn_hideBottomNavigation();
          }
          
          this.$refs['ref_dialogDataBackup'].openDialogWeb();
        }
        
        setTimeout(() => {
          called = false;
        }, 1000);
      });

      let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
          this.isMobileBrowser = true;
      } else {
        this.isMobileBrowser = false;
      }
    }
  }
</script>

<style>
/* .return .v-list .v-input .v-messages{
  display: block !important;
  white-space: normal !important;
} */
/* Accpuntbook css */
*{
  user-select: none !important;
}
input{
  user-select: text !important;
}
::-webkit-scrollbar {
  display:none;
}
.v-menu__content{
  z-index:9999 !important;
}
[no-round-borders], .no-round-borders{
  border-radius:0 !important;
}
[round-borders], .round-borders{
  border-radius: 5px !important;
}
[primary-color], .primary-color, .v-icon.primary-color, .primary--text{
  color: #4b77be !important;
}
[primary-background-color], .primary-background-color{
    background: #4b77be !important;
}
[redcolor], .redcolor, .v-icon.redcolor, .v-toolbar .v-icon.redcolor{
  color: red !important;
}
[greencolor], .greencolor, .v-icon.greencolor, .v-toolbar .v-icon.greencolor{
  color: green !important;
}
[whitecolor], .whitecolor, .v-icon.whitecolor, .v-btn .v-icon.whitecolor .v-toolbar .v-icon.whitecolor{
  color: #fff !important;
}
[color-light-grey], .color-light-grey{
  color: #999 !important;
}
[display-block], .display-block{
  display: block !important;
}
[capitalize], .capitalize{
  text-transform: capitalize !important;
}
input[type="time"]::-webkit-clear-button {
    display: none;
}
[border-light], .border-light{
  border: 1px #ddd solid !important;
} 
.print_template p, .bill_template p, .print_field p{
  margin:0 !important;
}
[height48], .height48{
  height:48px !important;
}
[bottom-fixed-footer], .bottom-fixed-footer{
  position: fixed !important;
  bottom: 0 !important;
  width: 100% !important;
}
[text-underline], .text-underline{
  text-decoration: underline !important;
}
[show-textbox-message] .v-messages,
.show-textbox-message .v-messages{
  display: block !important
}

[position-relative], .position-relative{
  position:relative;
}

[float-left], .float-left{
  float: left !important;
}
[float-right], .float-right{
  float: right !important;
}
.pr-1 .v-chip__content{
  padding-right: 4px !important;
}
.padding-right-8 .v-list__tile{
  padding-right: 8px !important;
}
.padding-right-0 .v-list__tile{
  padding-right: 0px !important;
}
.v-dialog.v-bottom-sheet{
  overflow-y: auto !important;
}
.oneline-tile-dense .v-list__tile{
  height: 36px !important;
}
.twoline-tile-dense .v-list__tile{
  height:54px !important;
}

.three-line-tile-height .v-list__tile{
  height: 88px !important;
}
.four-line-tile-height .v-list__tile{
  height: 104px !important;
}

.avatar-with-background .v-avatar{
  background-color:#F0F0F0;
}

.reference-panel{
  margin:0 !important;
}
.reference-panel .reference-header{
  font-size:16px !important;
  flex:none !important;
}
[font11], .font11{
  font-size:11px;
}
[font12], .font12{
  font-size:12px;
}

[sticky-top], .sticky-top{
    position: sticky !important;
    top:0 !important;
}

[sticky-bottom], .sticky-bottom{
    position: sticky !important;
    bottom:0 !important;
}

.create-placeholder-card{
  height: calc(100vh - 162px);
  display: flex;
  align-items: center;
}

.create-placeholder-card .placeholder-icon{
  width: 68px;
  height: 68px;
  border-radius: 10px;
  background: rgb(240, 240, 240);
  margin: auto;
  padding: 12px;
  position: relative;
}

.create-placeholder-card .placeholder-icon .add-icon{
  position: absolute;
  top: -10px;
  right: -10px;
  background: rgb(75, 119, 190) !important;
  border-radius: 5px;
  color: rgb(255, 255, 255) !important;
  font-size: 20px;
}

.create-placeholder-card .placeholder-icon img{
  opacity: 0.6;
  width: 42px;
}

.create-placeholder-card .placeholder-icon p{
  line-height: 28px !important;
}

.items-wrapper{
  padding: 12px 0px;
  background-color:#fff;
}
.reference-panel .v-card .v-card__text{
  color:rgba(0,0,0,0.54) !important;
  padding:0px 24px !important;
}
.reference-panel .v-card .v-card__text .card-items{
    display:flex !important;
    padding-bottom:5px !important;
}

.note-card .v-card__title{
  padding: 0px 0px 0px 16px;
  color:rgba(0,0,0,.54)
}

.snackbar-extra-large .v-snack__wrapper{
    padding: 16px 0px;
}

/* radio buttons debit/credit (dialog particulars)*/
.custom-radio-buttons .v-radio{
  width: 50%;
  margin: 0 !important;
  padding: 16px;
}
.custom-radio-buttons .v-radio .v-input--selection-controls__input{
  display: none;
}
.custom-radio-buttons .v-radio label{
  width: 100%;
}
.custom-radio-buttons .v-radio.activeNature label{
  color: rgba(0,0,0,0.87) !important;
}
.custom-radio-buttons .v-radio.activeNature{
  border-bottom: 3px #4b77be solid;
}
.custom-radio-buttons .v-input--radio-group{
  padding:0 !important;
}
.custom-radio-buttons .v-input--radio-group__input{
  border-bottom:1px #ddd solid;
}

/* against reference dialog */

.reference-items{
  padding: 16px 16px 8px 16px !important;
  color: rgba(0,0,0,0.72) !important;
}
.reference-items .layout{
  padding-bottom: 5px !important;
}
.amount-item .custom-text-field{
  margin-top: -6px
}
.amount-item .custom-text-field .v-input{
  margin:0 !important;
}

.amount-item input{
  text-align: right !important;
}

.right-align-textbox input{
  text-align: right !important;
}

.select-all-reference .v-input__slot{
  margin: 0 !important;
}

/* Accountbook css end */

.custom-avatar-tile .v-list__tile__avatar .v-avatar{
    height: 32px !important;
    width: 32px !important;
    background: #F0F0F0;
}

.accountbook-tile .account-name{
  float: left;max-width: calc(100% - 28px);overflow: hidden;text-overflow: ellipsis;
}
.accountbook-tile .amount-type{
  width:24px;
}
.return .v-text-field .v-input__slot:after, 
.return .v-text-field .v-input__slot:before{
  bottom: 0 !important;
}

[align-input-text-right], .align-input-text-right{
  text-align: right !important;
}
[align-flex-end], .align-flex-end{
  align-items: flex-end !important;
}
[small-right-textbox], .small-right-textbox{
  border: 1px #ddd solid;
  padding: 5px;
}
[note-card] .v-card__text, 
.note-card .v-card__text{
  overflow-wrap: break-word !important;
}
[white-space-pre-line], .white-space-pre-line{
  white-space: pre-line !important;
}
[overflowed-text], .overflowed-text{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.v-text-field__prefix{
  width: auto !important;
}
[height-auto], .height-auto{
  height: auto !important;
}
[grey-color], .grey-color{
  color: #999 !important;
}
[auto-height-tile] .v-list__tile, 
.auto-height-tile .v-list__tile{
  height: auto;
  padding: 10px 16px;
}
.multiline-text-tile .v-list__tile{
  height: auto !important;
  min-height: 72px !important;
  padding: 8px 16px !important;
}
.multiline-text-tile .v-list__tile .v-list__tile__title{
  height: auto !important;
  white-space: break-spaces !important;
}
[text-field-top-bottom-margin], .text-field-top-bottom-margin{
  margin: 8px 0px;
}
[toolbar-subtitle], .toolbar-subtitle{
  font-size: small;
  overflow: hidden;
  text-overflow: ellipsis; 
  transition: all 1s;
}
.two-line-title{
  font-size:18px !important;
  line-height:24px;
}
.two-line-title .toolbar-subtitle{
  line-height:18px; 
}
.two-line-title .toolbar-subtitle .subtitle-text{
  display:inline;
}
.two-line-title .toolbar-subtitle .v-icon.subtitle-icon{
  position:absolute;
  bottom:5px;
  color:rgba(0,0,0,0.87) !important;
}
.smooth-dnd-ghost{
  background:#fff !important;
  opacity:1 !important;
  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12) !important;
}

[no-items-list-card], .no-items-list-card{
  position:relative !important;
  padding: 0 !important;
}
.listHeaderHasButtons .v-subheader{
  padding: 0px 2px 0px 16px;
}
[border-bottom-thin], .border-bottom-thin{
  border-bottom: 0.5px #F0F0F0 solid !important;
}
[padding-all-16], .padding-all-16{
  padding:  16px !important;
}
[light-opacity-color], .light-opacity-color,
[light-opacity-color] .v-icon, .light-opacity-color .v-icon{
  color: rgba(0,0,0,.54) !important;
}
[dark-opacity-color], .dark-opacity-color{
  color: rgba(0,0,0,.87) !important;
}
[font-small], .font-small{
  font-size: small !important
}
[right-align-checkbox] .v-input--selection-controls__input,
.right-align-checkbox .v-input--selection-controls__input{
  position: absolute;
  right: 0;
  margin-right: 0;
}

[right-align-checkbox] label, .right-align-checkbox label{
  width: 100%;
}
.tile-checkbox-align-right{
  flex:1 !important;
}
[no-v-messages] .v-messages, .no-v-messages .v-messages{
 display: none !important;
}
[font6], .font6{
  font-size: 6px !important;
}
[font8], .font8{
  font-size: 8px !important;
}
[font10], .font10{
  font-size: 10px !important;
}
[font12], .font12{
  font-size: 12px !important;
}
[font14], .font14{
  font-size: 14px !important;
}
[font16], .font16{
  font-size: 16px !important;
}
[font20], .font20{
  font-size: 20px !important;
}
[font18], .font18{
  font-size: 18px !important;
}
.search-bar .v-input,
.search-bar .v-input__slot{
  background-color: #F0F0F0 !important;
}
[dark-grey], .dark-grey{
  background-color: #ddd !important;
}
[fade-opacity], .fade-opacity{
  opacity:0.2;
}
[border-radius-circle], .border-radius-circle{
  border-radius: 50%;
}
[visibility-hidden], .visibility-hidden{
  visibility:hidden;
}
#hidden_invoice_preview{
  visibility:hidden;
  top: -9999px;
  position: fixed;
}
.infinite-status-prompt{
  padding: 24px 10px 16px 10px !important;
}
[subheader-semi-dense], .subheader-semi-dense{
  height: 42px !important;
}
[subheader-dense], .subheader-dense{
  height: 36px !important;
}
[subheader-ultra-dense], .subheader-ultra-dense{
  height: 32px !important;
}
[justify-content-to-end] .v-btn__content, .justify-content-to-end .v-btn__content{
  justify-content: flex-end !important;
}
[margin-top-ten], .margin-top-ten{
  margin-top:10px;
}
[margin-bottom-ten], .margin-bottom-ten{
  margin-bottom:10px;
}
[margin-top-bottom-five], .margin-top-bottom-five{
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
[margin-bottom-five], .margin-bottom-five{
  margin-bottom: 5px !important; 
}
[align-msg-right] .v-messages,
.align-msg-right .v-messages{
  display: -webkit-box;
  -webkit-box-pack: end;
}
[align-msg-right] .v-messages.error--text,
.align-msg-right .v-messages.error--text{
  display: -webkit-box;
  -webkit-box-pack: start;
}
[custom-message], .custom-message{
  text-align: right;
  font-size: 12px;
  color: rgba(0,0,0,0.54);
  padding-top: 8px;
}
.error_background, .error_background input{
  background-color: rgba(255, 0, 0, 0.1);
}

.small-action-tile .v-list__tile__action{
  min-width:40px
}

.descrition-field textarea{
  margin: 0 !important;
  padding: 12px 12px 12px 0px;
}
.descrition-field .v-text-field--outline .v-input__slot{
  border: 1px solid rgba(0,0,0,.38) !important;
}
.descrition-field .v-text-field--outline.v-input--is-focused .v-input__slot{
  border: 1px solid currentColor !important;
}
.descrition-field .v-text-field--outline:not(.v-input--is-focused) .v-input__slot:hover{
  border: 1px solid rgba(0,0,0,.87) !important;
}

.medium-theme-color, [medium-theme-color]{
  color: rgba(0,0,0,.72) !important;
}
.light-theme-color, [light-theme-color]{
  color: rgba(0,0,0,.54) !important;
}
[display-flex], .display-flex{
  display: flex !important;
}
.no-left-margin{
  margin-left: 0 !important;
}
.noshadow, [noshadow]{
  box-shadow: none !important;
}
.bottom-shadow{
  box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
}
/* .v-toolbar .v-toolbar__content,
.v-toolbar__extension .v-tabs__bar{
  background-color:#4b77be !important;
} */
.v-toolbar .v-toolbar__content,
.v-toolbar__extension .v-tabs__bar{
  background-color:#ffffff !important;
  border-bottom:1px #ddd solid !important;
}

.v-toolbar.nobottomborder .v-toolbar__content{
  border-bottom: none !important;
}

.v-toolbar.white-background  .v-toolbar__content{
  background-color:#ffffff !important;
}

.v-toolbar .v-toolbar__extension .v-subheader .v-btn {
  color: #1e88e5!important;
}
/* .v-toolbar .v-icon,
.v-toolbar .v-btn{
  color:#fff !important;
} */
.v-toolbar .v-icon,
.v-toolbar .v-btn{
  color:#4b77be !important;
}

.v-toolbar .v-toolbar__side-icon,
.v-toolbar .v-toolbar__side-icon .v-icon{
  color:rgba(0,0,0,0.87) !important;
}

.search-filter .v-input{
  width: calc(100% - 48px);
  float: left;
}
.search-filter .filter-btn{
  /*height: 42px;
  border: 1px #ddd solid;*/
  text-align: center;
  padding: 10px 0px;
  color: rgba(0, 0, 0, 0.87);
  position: relative;
  width: 48px;
  height: 48px;
  float: right;
  background: #f0f0f0;
  border-right: 0;
}
.search-filter.two-btn .v-input{
  width: calc(100% - 96px);
}
.search-filter.three-btn .v-input{
  width: calc(100% - 144px);
}
.search-filter .filter-btn .v-icon{
  color: rgba(0,0,0,0.54) !important;
}
.search-filter .filter-btn .v-icon.primary-color{
  color: #4b77be !important;
}

/*.activity-tabs.fixed-tabs .search-filter .filter-btn{
  background: #fff !important;
}*/

/* .filter-chips{
  overflow: scroll;
  width: 100%;
  white-space: nowrap;
  padding: 4px;
}
.filter-chips .v-chip__content{
  font-size: 12px;
  height: 28px;
} */

.v-toolbar.white-background .v-icon,
.v-toolbar.white-background .v-btn{
  color: rgba(0,0,0,.87) !important;
}

.top-bottom-padding, [top-bottom-padding]{
  padding: 16px 0px !important;
}
.v-toolbar__extension{
  padding: 0 !important;
}
.v-toolbar__extension{
  height:auto !important;
}
/*.v-toolbar__extension, 
.v-toolbar__extension .v-input, 
.v-toolbar__extension .v-input__control {
  height: 42px !important;
  min-height: 42px !important;
}*/
.v-toolbar__extension .v-input__control .v-input__slot{
  background-color: #F0F0F0 !important;
  margin: 0;
  border-radius: 0;
}
[right-border], .right-border{
  border-right: 1px #ddd solid !important;
}
[right-align], .right-align{
  text-align: right !important;
}
[left-align], .left-align{
  text-align: left !important;
}
[center-align], .center-align{
  text-align: center !important;
}

.circle_arrow_icon.v-icon{
  background: #eee;
  border-radius: 50%;
  padding: 2px;
  margin-right: 2px;
  /* vertical-align: top !important; */
  font-size: 16px !important;
}

/*.fade-enter-active, .fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}*/

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
} 

.hasToolbar{
  padding-top: 56px !important;
}
.hasToolbar.hasExtension{
  padding-top: 104px !important;
}
.hasToolbarAndTabs{
  padding-top: 102px;
}
.hasFooter{
  padding-bottom: 40px;
}
.hasBigFooter{
  padding-bottom: 72px; 
}
.hasBigFooterWithExtention{
  padding-bottom: 100px; 
}
.hasBigFooterWithExtentionPlus{
  padding-bottom: 116px; 
}
[overflow-scroll], .overflow-scroll{
  overflow: scroll;
}
.v-toolbar__content{
  height: 56px !important;
}
.v-toolbar__title{
  /* color: #4b77be !important; */
  color:rgba(0,0,0,0.87) !important;
  font-weight: normal !important;
}
.v-toolbar.nopadding .v-toolbar__content{
  padding: 0 !important;
}
.v-toolbar.norightpadding .v-toolbar__content{
  padding-right: 0 !important;
}
/* .v-dialog{
  margin: 16px;
} */
.v-alert{
  margin: 0px;
  padding: 8px 16px;
  border: 0;
}
.v-alert.info{
  background-color:#edf0f7 !important;
  color:rgba(0,0,0,0.87) !important;
}
.v-alert.warning{
  background-color:#fb8c00!important;
}
.v-alert.primary{
  margin: 0px;
  padding: 8px 16px;
  border: 0;
}

.v-alert.warning .v-alert__icon.v-icon{
  color: #ffffff !important;
}

.v-alert.info .v-alert__icon.v-icon{
  color:rgba(75, 119, 190, 1) !important;
}
.v-alert.info .v-btn{
  color:rgba(0,0,0,0.87) !important;
}
.v-icon{
  color: #666666 !important;
}
[font-normal], .font-normal{
  font-weight: 400 !important;
}
[font-medium], .font-medium{
  font-weight: 500 !important;
}
[font-heavy], .font-heavy{
  font-weight: 600 !important;
}

.alert-container{
  display: flex;
  background: #fff3cd;
  color: #856404 !important;
  border-color: #ffeeba;
  border: 0.5px solid;
  font-weight: 500;
}

.alert-container .v-icon{
  color: #856404 !important;
}

.alert_tile .v-list__tile{
  padding-left: 8px;
  padding-right: 0px;
}

.info-container{
  display: flex;
  background: #ecf7f3;
  color: #0f5132 !important;
  border-color: #0f5132;
  border: 0.5px solid;
  font-weight: 500;
}

.info-container .v-icon{
  color: #0f5132 !important;
}

/*======================== quill editor ====================*/
.ql-size-small{
  font-size: .75em;
}
.ql-size-large{
  font-size: 1.5em;
}
.ql-size-huge{
  font-size: 2.5em;
}
/*======================== quill editor end ====================*/

/* body{
  height: 100%;
} */
/* html, body, #app, main, .table_wrapper */
html, body, #app, main, .table_wrapper{
  height: 100%;
  background: #fff;
}
.parent-container{
  padding: 0 !important;
  height: 100%;
}
.uppercase, [uppercase]{
  text-transform: uppercase !important;
}
.right-subtitle-tile .right_subtitle{
  padding: 2px 16px;
  position: absolute;
  /* top: 6px; */
  right: 0;
  font-size: 16px;
  /* font-weight: 700; */
  color: rgba(0,0,0,0.87);
}
.right-subtitle-tile .v-list__tile__action{
  align-items: flex-start;
  padding-top:10px;
}
.v-list__tile--link:hover{
  background-color: #ffffff !important;
}
.v-expansion-panel__header{
  padding: 12px 16px !important;
}
.designer-container .v-expansion-panel__header{
  padding: 0px !important;
}
.v-expansion-panel{
  margin-bottom: 10px;
  box-shadow: none !important;
}
.align-normal{
  align-items: normal !important;
  padding-top: 14px !important;
}
.action-small{
  min-width: 36px !important;
}
[hide-messages] .v-messages,
.hide-messages .v-messages{
  display: none !important
}
/* .parent-container .display_wrapper{
  height:  100%;
  background-color: #F0F0F0;
} */

.content--wrap .container{
  padding: 0;
}
.progress-circular{
  margin-right: 16px;
}
.align_vertical_middle{
  display: flex;
  align-items: center;
}
.toolbar .toolbar__content .btn:first-child{
    margin-left: 8px !important;
}
.toolbar .toolbar__content .toolbar__title{
    margin-left: 0;
}
.toolbar .toolbar__content .toolbar__title.marginleft16{
    margin-left: 16px !important;   
}
.main_toolbar .toolbar__content .btn{
    margin: 6px 8px !important;
}
.btn__content .mdi{
    font-size:  24px;
}
.dialog{
    background-color: #fff;
}
.dialog__content .dialog .container{
    height: 100%;
    padding-top: 48px;
    overflow: hidden;
    padding-left: 0;
    padding-right: 0;
}
.container .tabs, 
.container .tabs .tabs__content,
.dialog__content .dialog .container .layout{
    height: 100%;
}
.tabs__bar{
  border-bottom: 1px #F0F0F0 solid;
}
.tabs__items{
  height: calc(100% - 48px);
}
.dialog__content .dialog .container .layout .left_side,
.dialog__content .dialog .container .layout .right_side{
    height: 100%;
    overflow: auto;
    padding: 0;
}
.dialog__content .dialog .container .layout .left_side .list{
  padding: 0;
}
.dialog__content .dialog .container .layout .left_side{
    border-right: 1px #F0F0F0 solid;
}

/* Form css */

/* .check_box label{
  left: 0 !important;
}
.check_box .icon{
  right: 0 !important;
  left: auto !important;
} */
/* .check_box .input-group--selection-controls__ripple{
  right: 0 !important;
  left: auto !important;
  -webkit-transform: translate(-12px,-50%) !important;
  transform: translate(12px,-50%) !important;
} */

/* Form Css */

/* .check_box .v-input--selection-controls__input{
  position: absolute !important;
  right: -10px !important;
} */

/* .check_box label.v-label{
  width: calc(100% - 60px) !important;
} */
[right-align-radio] .v-input--selection-controls__input,
.right-align-radio .v-input--selection-controls__input{
  position: absolute;
  right: 0;
} 
[right-align-radio] .v-radio,
.right-align-radio .v-radio{
  margin-bottom: 16px !important;
}

.right-align-message .v-messages{
  text-align:right;
}

.v-radio{
  margin-right: 24px !important;
}

.v-radio:last-child{
  margin-right: 0 !important;
}

.white-background, [white-background]{
  background-color: #ffffff !important;
}

/* .textfield_icon{
  width: 10.5px;
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 22px;
  margin: auto;
} */
.v-text-field.v-input--is-disabled .v-input__slot:before{
  border-image: none !important;
  border-color: rgba(0,0,0,.38) !important;
}

/* ================ Form View Css ================*/
.dialog_searchbox .v-text-field__details{
  display: none !important;
}
.v-dialog .v-card .v-card__title.dialog_searchbox{
  padding: 0 !important;
}
.dialog_searchbox .v-input__slot{
  margin:  0 !important;
  background: #F0F0F0 !important;
}
.form_wrapper{
  background-color: #F0F0F0;
}

.form_wrapper .section-wrapper{
    padding: 10px 0px;
    margin-bottom: 10px;
    background-color: #fff;
}

.form_wrapper .section-wrapper.has-subheader{
    padding-top:0px !important;
}

.form-item, [form-item],
.form_wrapper .form-item, 
.form_wrapper [form-item] {
  padding: 0px 16px !important;
  width:100%;
}

.form_wrapper [form-section-header]{
  border-bottom: 0.5px solid;
  border-color: rgba(0,0,0,0.12);
}

.margin-bottom-16, [margin-bottom-16]{
  margin-bottom: 16px;
}

.form_wrapper .form_wrapper .v-radio{
  margin-right: 24px !important;
}

.sibling-form-field{
  padding-right: 16px !important;
}

.custom-label-field .v-input{
  margin-top: 0;
}

[padding-top-bottom-ten], .padding-top-bottom-ten{
  padding:10px 0px !important; 
}
[padding-top-ten], .padding-top-ten{
  padding-top: 10px !important;
}
[padding-bottom-ten], .padding-bottom-ten{
  padding-bottom: 10px !important;
}

/*.custom-action-tile .v-list__tile__content{
  padding-right: 48px;
}
.custom-action-tile .right_subtitle{
  bottom: 10px;
}
.custom-action-tile .v-list__tile__action{
  position: absolute;
  right: 10px;
  padding-top: 16px;
}*/
.custom-action-tile .v-list__tile{
  align-items: flex-start !important;
}
.custom-action-tile .v-list__tile__action{
  align-items: flex-end !important;
  min-width: auto !important;
  padding:0 !important;
  white-space: nowrap !important;
}
.custom-action-tile .v-list__tile__action .remove_btn{
  position:absolute;
  bottom:6px;
  right:16px;
}

.batch_display_container .v-expansion-panel{
  margin-top: -12px !important;
}
.batch_display_container .v-expansion-panel__header{
  height: 32px;
  background: rgba(66, 165, 245, 0.15);
}
/* ================ Display View Css ================*/
.display_wrapper{
  height: 100%;
}
.display_wrapper .display{
  /* padding:0px !important; */
  background-color: #F0F0F0;
}
.display_wrapper .display .display_title{
  padding: 16px;
  margin-bottom: 10px;
  background-color: #fff;
  font-size: 24px;
}
.display_wrapper .display .section-container{
  padding: 0 !important;
  margin-bottom: 10px !important;
}

/* ================ Global Css ================*/
[big-height-tile], .big-height-tile{
  height:72px !important;
}
.nopadding, [nopadding]{
  padding: 0px !important;
}
.nomargin, [nomargin]{
  margin: 0px !important;
}
.nomargin.v-input--checkbox .v-input__slot{
  margin:0 !important;
}
.norightpadding, [norightpadding]{
  padding-right: 0 !important;
}
.dialog-card-content, [dialog-card-content]{
  padding: 16px 0px !important;
  height: 100% !important;
}
.full-width, [full-width]{
  width: 100% !important;
}
.full-width-light, [full-width-light]{
  width: 100%;
}
.full-height, [full-height]{
  height: 100% !important;
}

/* ================ Small check box Css ================*/
.small-checkbox{
  padding:0 !important;
}
.small-checkbox .v-input--selection-controls__input{
  margin:0 !important;
}
.small-checkbox .v-input__slot .v-icon{
  font-size:18px !important;
}
.small-checkbox .v-input__slot .v-label{
  font-size:14px !important
}
/* ================ End of small check box Css ================*/

.v-dialog .v-card .v-card__title{
  padding: 16px;
  box-shadow: 0 2px 4px -1px rgba(0,0,0,.01), 0 4px 5px 0 rgba(0,0,0,.01), 0 1px 10px 0 rgba(0,0,0,.12);
}
[errortxt]{
  font-size: small;
}
[full-width-label] label{
  width:  100% !important;
}

.scrollauto-y{
  overflow-y: auto !important;
}

.noscroll{
  overflow: hidden !important;  
}

.single-selection-dialog .v-input__control .v-radio,
[single-selection-dialog] .v-input__control .v-radio{
  margin: 0 !important;
  padding: 10px 48px 10px 0px !important;
}

.single-selection-dialog .v-input__control .v-radio .v-input--selection-controls__input, 
[single-selection-dialog] .v-input__control .v-radio .v-input--selection-controls__input{
  position: absolute;
  right: 0;
}

.v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before{
  background-color: transparent !important;
}

.grey-back, [grey-back]{
  background-color: #F0F0F0 !important;
}

/*=============== Tabs ==================*/
.v-tabs__item--active,
.sticky_tabs.toolbar_tabs .v-tabs__item--active{
  color:#4b77be !important;
}
.sticky_tabs.toolbar_tabs .v-tabs__bar{
  background: #fff !important;
}
.sticky_tabs.toolbar_tabs .v-tabs__slider{
  background-color: #4b77be !important;
  border-color: #4b77be !important;
}
/* .toolbar_tabs .v-tabs__item--active{
  color: #fff !important
} */
.toolbar_tabs .v-tabs__item,
.toolbar_tabs .v-tabs__item--active{
  color: #4b77be !important
}
.v-tabs__slider-wrapper .v-tabs__slider{
  background: #4b77be !important;
}
.fixed-tabs .v-tabs__container{
  height: 56px;
}
.fixed-tabs{
  padding-top: 56px;
}
.fixed-tabs .v-toolbar__content{
  padding: 0;
}
.fix_width_tabcount2 .v-tabs__slider-wrapper,
.fix_width_tabcount2 .v-tabs__div{
  width: 50% !important;
}

.display_msg{
    position: absolute;
    /* top: 0;
    bottom: 0; */
    display: flex;
    align-items: flex-end;
    width: 100%;
    justify-content: center;
    padding: 16px;
    color: rgba(0,0,0,.54) !important;
}
.display_msg.pos_inherit{
    position: inherit !important;
}
.v-tabs{
  border-bottom: 1px #F0F0F0 solid;
}

/* Custom Css */
.small-textbox-container .layout-wrap{
  min-height:54px;
}

.small-textbox-container .layout-wrap .small-textbox-label{
  display: flex;align-items: center;font-size:16px;
}

.small-textbox-container .layout-wrap .small-textbox .v-text-field{
  margin-top:10px;
}

.small-textbox-container .layout-wrap .small-textbox .v-text-field input{
  text-align: right;
}

[list-checkbox] .v-list__tile__action .v-input .v-input__slot,
.list-checkbox .v-list__tile__action .v-input .v-input__slot{
    justify-content: flex-end !important;
}

.warning-label{
  /* position: absolute;
  bottom: 8px;
  right: 0; */
  padding: 4px 16px;
  color: #fff;
  font-size: 12px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  margin-right: -16px;
  background-color:#fb8c00!important;
}
.bill_template .invoice_cancel_label{
  display: inline-block;
  margin-right: -4px;
  background: #eee;
  font-weight: 600 !important;
  padding: 4px 6px 2px 6px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  font-size: 12px !important;
  color: red !important;
}
[align-flex-end], .align-flex-end{
  align-items: flex-end !important;
}

.draft-items-info{
  text-decoration: underline;
}
.draft-items-info .right-side-content{
  position: absolute; 
  right: 16px;
}
.invalid-item{
  background-color:#F0F0F0;
  border: 1px #ff0000 solid;
}

/* ------------------------- Draft Tab Css -------------------- */
.draft_content .search-bar .v-input__append-outer{
  margin-top: 7px !important;
}
.draft_content .search-bar .v-input__append-outer .v-icon{
  margin: 0px !important;
}
.draft_content .fixed_top{
  position:fixed;
  top:56px;
  width:100%;
  z-index:101;
  background-color: #fff;
}
/* ------------------------- Draft Tab Css End -------------------- */

/*----------------- Activity Tab Css ----------------------*/
/* .activity-tabs.fixed-tabs .v-toolbar__extension,
.activity-tabs.fixed-tabs .v-toolbar__extension .v-input__control,
.activity-tabs.fixed-tabs .v-toolbar__extension .v-input{
  height: 38px !important;
  min-height: 38px !important;
} */

/*.activity-tabs.fixed-tabs .search-box.v-input,
.activity-tabs.fixed-tabs .search-box .v-input__control,
.search-bar .v-input,
.search-bar .v-input__control{
  height: 42px !important;
  min-height: 42px !important;
}*/

/* .activity-tabs.fixed-tabs{
  padding-top:94px;
} */
/* .activity-tabs.dashboard{
  padding-top:92px;
} */
/* .activity-tabs.due-payments{
  padding-top:144px;
} */
/* .activity-tabs.fixed-tabs .search-box{
  position: fixed;
  width: 100%;
  z-index: 999;
  top: 56px;
} */
.activity-tabs.fixed-tabs .search-box .v-input__slot{
  background: #F0F0F0;
  /*border: 1px #ddd solid;*/
  border-left: 0 !important;
  border-right: 0 !important;
  margin:0 !important;
}

/* .filter-header{
  position: fixed;
  top: 56px;
  z-index: 9;
  width: 100%;
  background: #F0F0F0;
  padding-right: 0 !important;
} */

/*.filter-display{
  height: 52px;
  width: 100%;
  font-size:12px;
  clear: both;
}
.filter-display .display-block{
  border-radius: 5px;
  padding: 4px 8px;
  margin: 4px 8px;
  border: 1px #ddd solid;
}*/
.filter-display{
  height:58px;border-top:1px #ddd solid;border-bottom:1px #ddd solid;clear:both;
}

.filter-display .display-block{
  height:48px;
  margin: 4px;
  padding: 2px 8px;
  border-radius: 5px;
}

.filter-display .display-block .filter-display-value{
  line-height:22px;
}

.merged_tnumber{
  /*color: #1976d2;*/
  text-decoration: underline;
}
.v-alert.grey-alert{
  margin: 0;
  background-color: #ddd !important;
  color: #4b77be !important;
  border-bottom: 1px #4b77be solid !important;
  font-size: 16px;
}
.v-alert.grey-alert .v-alert__icon{
  color: #4b77be !important;
  margin-right: 0;
  width: 56px;
}
.content-loader{
  padding-bottom: 32px;
}
.payment-reminder-canvas{
  position: absolute;
  top: -999px;
  border: 1px solid black;
}

#reminder_node{
    position: absolute;
    top: -9999px;
}

.expense-bars{
  padding: 16px 0px;
}
.expense-bars .background-div{
  height:48px;background:#F0F0F0
}
.expense-bars .front-div{
  height:48px;transition: width 2s ease;
}
.expense-bars .front-div.purchase{
  float: left;
  background:#1976d2;
}
.expense-bars .front-div.expense{
  float: right;
  background:orange;
}

/*----------------- Activity Tab Css End ----------------------*/


/*----------------- Print out watermark css ----------------------*/
.transform-preview-with-items-xlarge{
  transform: scale(0.6);
}

.transform-preview-with-items-large{
  transform: scale(0.7);
}

.transform-preview-with-items{
  transform: scale(0.8);
}

.transform-preview{
  transform: scale(0.9);
}

.page-footer, .page-footer-space {
  height: 50px;
}
.page-footer {
  text-align:right;
  position: fixed;
  bottom: 0;
  right:0;
}

.preview .page-footer {
  position: inherit !important;
}

.page-footer.custom{
  height: auto !important;
  width: 100%;
  background: #fff;
}

.branding{
  width:fit-content;
  padding:4px 16px;
  text-align: right;
  margin:auto;
} 

.preview .branding{
  width: auto !important;
}

.page-footer.custom .branding{
  width: auto;
}

.watermark{
  padding:4px !important;
  opacity:0.2 !important;
}

.disabled-item-color{
  color: rgba(0,0,0,0.2);
}

.watermark .title{
  display:block !important;
}

.branding .title{
  font-weight: 600;
  font-style:italic;
  display:flex;
  align-items:center;
}
.brand_logo{
  width:24px;
  margin-right:6px;
}
.brand_logo.logo_small{
  width:10px;
  margin-right:2px;
  margin-bottom: -2px;
}
.branding a{
  text-decoration: none;
}
/*----------------- Print out watermark css end ----------------------*/

/*----------------- Select field dialog css ----------------------*/
.select_field_dialog .v-input{
  padding-top: 0;
  margin:0;
}
.select_field_dialog .v-input .v-radio{
  margin-bottom:12px;
}
.select_field_dialog .v-input .v-radio .v-label{
  width: 100%;
}
/*----------------- Select field dialog css end ----------------------*/

/*----------------- Transaction settings css ----------------------*/
.switches .v-input--selection-controls__input{
  position: absolute;
  right:0;
}
.switches  .v-input--switch{
  padding: 16px 16px 0px 16px !important;
}
input[aria-label="App Lock"]{
  color: rgba(0,0,0,0.87) !important;
}
.v-input--switch.hide-margins .v-input__slot,
.v-input--switch.hide-margins .v-input__slot .v-input--selection-controls__input{
  margin:0 !important;
}
/*----------------- Transaction settings css end ----------------------*/

/*----------------- quill editor css ----------------------*/
.quill-editor .ql-toolbar{
  position: fixed;
  bottom: 0;
  background: #fff;
  z-index: 9;
  width:100%;
}
.quill-editor.hasFoooterBtn .ql-toolbar{
  bottom:48px !important;
}
.quill-editor .ql-container{
  border:0 !important;
  font-size:16px;
}
.ql-size.ql-picker .ql-picker-options{
  top:-166px !important;
}
/*----------------- quill editor css end ----------------------*/

/* ----------------- Return Form Dialog ------------------- */
.return #scrollable_div{
  padding-top:104px !important
}

.video-link-tile{
  background-color: rgba(66, 165, 245, 0.15) !important;
}

.video-link-tile.two-line .v-list__tile{
  background-color: rgba(66, 165, 245, 0.15) !important;
}


.list-checkbox{
  min-width: 42px !important;
}

.business-logo-view .logo-img{
  max-height:120px;
  max-width:120px;
  border: 4px #ddd solid;
}
.business-logo-view .logo-placeholder{
  width: 120px;
  height: 120px;
  padding:44px 32px;
  margin: auto;
  font-size:16px;
  color:rgba(0,0,0,0.2)
}
.business-logo-view .logo-placeholder .v-icon{
  font-size: 92px;
  padding: 48px;
}

.small-switch .v-input__slot{
  height:10px;
}

.small-switch .v-input__slot .v-input--selection-controls__input{
  width:22px;
}

.small-switch .v-input__slot .v-input--selection-controls__input .v-input--switch__track{
  height:7px;
  opacity:0.4;
  top: calc(50% - 6.4px);
}

.small-switch .v-input__slot .v-input--selection-controls__input .v-input--switch__thumb{
  width: 9px;
  height: 9px;
  top: calc(50% - 8px);
  left:1px;
}

.small-switch .v-input--selection-controls__ripple{
  width:24px;
  height:24px;
  display:none;
}

.small-switch.v-input--switch.v-input--is-dirty .v-input--switch__thumb,
.small-switch.v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple{
  transform: translate(11px) !important;
}
/* Crop Image Css */
.croppie-container{
  height:auto !important;
}
.cr-boundary{
  width:100% !important;
}

/* ================= invoice template css ======================= */
.hasborder{
  border: 1px #ddd solid;
}
.invoice-footer{
    display: flex;
    justify-content: flex-end;
}
.invoice-footer .branding{
    padding:0 !important;
    border-radius:5px;
    margin:inherit !important;
}
.invoice-footer .branding .branding-box{
    padding:4px 8px;
    border-radius:5px;
}
.invoice-footer .branding .branding-box .powered{
    font-size:9px !important;
    line-height:12px;
}
.invoice-footer .branding .branding-box .title{
    line-height:18px;
    font-size:16px !important;
    align-items: center;
}
.invoice-footer .branding .branding-box .title .brand_logo{
    width:14px;
    height:14px;
    margin-right:4px;
    margin-bottom:0px
}

/* .row-app-logo td{
  position: relative;
}
.row-app-logo td .invoice-footer{
  border: 1px #ddd dashed;
  padding: 12px;
  border-radius: 5px;
  width: fit-content;
  display: inline-block !important;
}
.row-app-logo td .v-input{
  position: absolute;
  right: 8px;
  background: #fff;
  padding: 0px 8px;
  bottom: 10px;
} */

.row-app-logo{
  position: relative;
}
.row-app-logo .invoice-footer{
  border: 1px #ddd dashed;
  padding: 12px;
  border-radius: 5px;
  margin-left: 16px;
  /* width: fit-content; */
  /* display: inline-block !important; */
}
.row-app-logo .v-input{
  position: absolute;
  right: 8px;
  background: #fff;
  padding: 0px 8px;
  bottom: 6px;
}

.invoice-footer-actions{
  height:auto !important;
  position:fixed;
  bottom:0;
  width:100%;
  z-index:9;
  border-top:1px #ddd solid;
}
.bill_template *{
  /* font-size: 8px !important;
  line-height: 12px; */
  font-size: 10px !important;
  line-height: 14px;
  color: #000 !important;
  font-weight: 500 !important;
}
.bill_template .font-heavy{
  font-weight: 600 !important;
}
.bill_template div *{
  line-height: 12px;
}
.bill_template strong{
  font-weight: 600 !important;
}
.bill_template.font_small *{
  font-size: 8px !important;
  line-height: 12px;
}
.bill_template.font_large *{
  font-size: 12px !important;
  line-height: 16px;
}
.bill_template.font_xl *{
  font-size: 14px !important;
  line-height: 18px;
}
.bill_template.font_xxl *{
  font-size: 16px !important;
  line-height: 20px;
}
.bill_template{
  /* font-size: 12px; */
  background:#fff;
  line-height: 20px;
}

.bill_template .ql-size-small{
    font-size: 0.75em !important;
}
.bill_template .ql-size-large{
    font-size: 1.5em !important;
}
.bill_template .ql-size-huge{
    font-size: 2.5em !important;
}

.bill_template table{
  height:1px;
  border-collapse: collapse;
}

.bill_template table tr td{
  padding: 4px;
  border:1px #000 solid;
  /* vertical-align: top; */
  vertical-align: middle;
  height: inherit;
}


.bill_template .business_details{
  word-break: break-word;
}
.bill_template .business_details img{
  max-width: 80px;
}

.bill_template table tr { height: 1px }
.bill_template table tr td > div { height: 100%; }
.bill_template.template_101 table tr td > div { height: auto; }

.bill_template table .header_template5 tr{ height: auto !important;}

.bill_template.template_101 table tr { height: auto !important }

.bill_template.gridall table tr td *{
  border-color: rgba(0,0,0) !important;
}

.bill_template.gridall table tr td{
  border: 1px solid rgba(0,0,0) !important;
  padding: 0px 4px;
  /* padding: 4px 4px 0px 4px; */
  height: 1px !important;
}

.bill_template.gridall table tr.items_row td,
.bill_template.gridall table thead.items_header td,
.bill_template.gridall table tr.items_footer td,
.bill_template.gridall table tr.hsn_row td,
.bill_template.gridall table tr.hsn_row_1001 td{
  padding: 4px;
}

.bill_template.gridall table tr td .col50_2,
.bill_template.gridall table tr td .col33_3,
.bill_template.gridall .single-column-double-section .left-column,
.bill_template.gridall table tr td .bottom-left-column{
  border-right: 1px solid rgba(0,0,0);
}
.bill_template.gridall table tr td .col50_2:last-child,
.bill_template.gridall table tr td .col33_3:last-child{
  border-right: 0 !important
}

/* .bill_template.gridall table tr td .terms-section,
.bill_template.gridall table tr td .printnote-section{
  border-bottom: 1px solid rgba(0,0,0,.4);
  margin-left: -4px;
  padding-left: 4px;
} */

.bill_template.gridall tr td .bottom-row-container .bottom-left-column > div:not(:last-child){
  border-bottom: 1px solid rgba(0,0,0) !important;
  margin-left: -4px;
  padding-left: 4px;
}

.bill_template.gridall table tr td .topborder{
  border-top: 1px solid rgba(0,0,0);
  margin-left: -4px;
  padding-left: 4px;
}

.bill_template.gridall table tr td .other-field-item{
  border-bottom: 1px solid rgba(0,0,0);
  margin: 0px -8px 0px -8px;
  padding-left: 8px;
}
.bill_template.gridall table tr td .other-field-item:last-child{
  border-bottom: 0 !important;
}

.bill_template.gridall table tr td .header-right-section{
  padding: 0px;
}
.bill_template.gridall table tr td .header-right-section div{
  border-bottom: 1px solid rgba(0,0,0);
  margin-right: -4px;
  padding:2px 4px;
}
.bill_template.gridall table tr td .table_div .table_div_row{
  border-bottom: 1px solid rgba(0,0,0);
}
.bill_template.gridall table tr td .table_div .table_div_row .table_div_col{
  padding:2px 4px;
}
.bill_template.gridall table tr td .table_div .table_div_row:last-child{
  border-bottom: 0 !important;
}

.bill_template.gridall table tr td .header-right-section div:last-child{
  border-bottom: 0;
}

/* .bill_template.gridall table tr td .upi-details-section{
  border-right: 1px solid rgba(0,0,0,.4);
} */

.bill_template.griditems table thead.items_header td,
.bill_template.griditems table tr.items_row td,
.bill_template.griditems table tr.items_footer td{
  border: 1px solid rgba(0,0,0) !important;
}

.bill_template.griditems table tr.items_row td, 
.bill_template.gridall table tr.items_row td,
.bill_template.griditems table tr.items_row,
.bill_template.gridall table tr.items_row{
  border-top: 0 !important;
  border-bottom: 0 !important;
}

/* .bill_template.gridall table tr.items_row.add_bottom_border{
  border-bottom: 1px #000 solid !important;
} */

.bill_template table tr.items_row.add_bottom_border{
  border-bottom: 1px #000 solid !important;
}


.bill_template.griditems table tr td.border-top-none,
.bill_template.gridall table tr td.border-top-none{
  border-top:0 !important
}

.bill_template.griditems table tr td.border-bottom-none,
.bill_template.gridall table tr td.border-bottom-none,
.bill_template.gridall table:first-child tbody tr:last-child td{
  border-bottom:0 !important
}

/* grid css template 2 */
.bill_template.gridall table tr td .bottomborder{
  border-bottom: 1px solid rgba(0,0,0);
}
.bill_template.template_2.gridall table tr td.business_row{
  padding-right: 0px;
}
.bill_template.template_2.gridall table tr td.business_row .col50_2:last-child .layout div.flex{
  border-right: 1px solid rgba(0,0,0);
}
.bill_template.template_2.gridall table tr td.business_row .col50_2.placeofsupply:last-child .layout.invoice_details div.flex:nth-child(3){
  border-right:0
}
.bill_template.template_2.gridall table tr td.business_row .col50_2.noplaceofsupply:last-child .layout.invoice_details div.flex:nth-child(2){
  border-right:0
}
.bill_template.template_2.gridall table tr td.business_row .col50_2:last-child .layout.other_details div.flex:nth-child(3){
  border-right:0
}
.bill_template.gridall table tr td .borderwhite,
.bill_template.gridall table tr td.borderwhite{
  border-color: #ffffff !important;
}
.template_2.gridall .col50_2:first-child > div.border-top{
  border-top: 0 !important;
}
.template_2.gridall .col50_2:first-child > div:not(:last-child){
  border-bottom: 1px solid rgba(0,0,0) !important;
  margin-left: -4px;
  padding-left: 4px;
}
/* ================== */

/* grid css template 3 */
.bill_template.template_3.gridall table tr td.business_row{
  padding-right: 0 !important;
}
.template_3.gridall .col50_2:first-child > div.border-top{
  border-top: 0 !important;
}
.template_3.gridall .col50_2:first-child > div:not(:last-child){
  border-bottom: 1px solid rgba(0,0,0) !important;
  margin-left: -4px;
  padding-left: 4px;
}
/* ================== */

/* grid css template 4 */
.bill_template.template_4.gridall table tr td.business_row{
  padding-right: 0 !important;
}
.bill_template.gridall table tr td .rightborder{
  border-right: 1px solid rgba(0,0,0);
}
.bill_template.template_4.gridall table tr td .col33_3 .bottomborder:last-child{
  border-bottom:0;
}
/* ================== */

/* grid css template 5 */
.bill_template.template_5.gridall table tr td .col33_3 .bottomborder:last-child{
  border-bottom:0;
}
/* ================== */

/* grid css template 6 */
.bill_template.template_6.gridall table tr td.business_row{
  padding-right: 0 !important;
}
/* ================== */

.bill_template .col33_3{
  width:33.3%;
  float:left;
  padding:8px;
}

.bill_template .col33_33{
  width:33.3%;
  float:left;
  padding:4px;
}

.bill_template .col50_2{
  width:50% !important;
  float:left;
  padding:8px;
}

.no-right-padding{
    padding-right:0px !important
}

.no-left-padding{
    padding-left:0px !important
}

/* .bill_template .col25{
  width:25% !important;
  float:left;
  padding:8px;  
} */

.bill_template .border-right{
  border-right:1px #000 solid;
}

[noborder], .noborder, .noborder tr td, .noborder td{
  border:none !important; 
}

.bill_template .single-column-double-section{
  padding: 0px 4px;
  padding-right: 0 !important;
}
.page.receipt_template .single-column-double-section .left-column,
.page.receipt_template .single-column-double-section .right-column,
.bill_template .single-column-double-section .left-column,
.bill_template .single-column-double-section .right-column{
  width: 50%;
  float: left;
  padding:4px 0px !important;
}

.bill_template .col67{
  width:67%;
  float:left;
  padding:4px 0px;
}

.bill_template .col33{
  width:33%;
  float:left;
  padding:4px 0px;
}

.bill_template .col75{
    width:75%;
    float:left;
    padding:4px 0px;
}

.bill_template .col25{
    width:25%;
    float:left;
    padding:4px 0px;
}

.bill_template .upi-details-section{
    float: left;
    padding-top: 8px !important;
    padding-right: 16px !important;
    width: 55%;
}

.bill_template .upi-details-section .qr-code-container{
    float:left;
    margin-right:8px;
    padding-top:4px;
}

.bill_template .upi-details-section .qr-code-container img{
    width: 48px;
}

.qr-code-details{
    padding-left:56px
}

.bill_template .bank-details-section{
    float:left;
    padding-top:8px!important;
    /* padding-left: 4px; */
    width:45%;
}

.bill_template .signature-section{
    display:flex;
    align-items:flex-end;
    justify-content:right;
}

.bill_template.non-editable .signature-section{
    position: absolute;
    right:0;
}

.bill_template .table_div{
  display: table;
  width:100%
}
.bill_template .table_div_row{
  display: table-row;
}
.bill_template .table_div_col{
  display: table-cell;
}

.bill_template .table_div_row .table_div_col:last-child{
  width: 1%;
  padding-left: 12px;
}

.bill_template .border-bottom{
  border-bottom:1px #ddd solid !important;
}
.bill_template .border-left{
  border-left:1px #ddd solid !important;  
}
.bill_template .border-right{
  border-right:1px #ddd solid !important; 
}
.bill_template .border-top{
  border-top:1px #ddd solid !important;
}

.bill_template .border-top-dark{
  border-top:1px #000 solid !important;
}

.bill_template .border-bottom-dark{
  border-bottom:1px #000 solid !important;
}

.bill_template .bottom-row-container{
    width:100%;
    display:table;
}
.bill_template .bottom-left-column{
    display: table-cell;
    width: 67%;
    padding: 4px 0px;
}
.bill_template .bottom-right-column{
  position:relative;
  height: 100%;
  display: table-cell;
  vertical-align: bottom;
  width: 33%;
}

/*.bill_template .bottom-right-column .signatory{
  padding: 12px;
}*/

.page.receipt_template .signatory img,
.bill_template .bottom-right-column .signatory img{
    /* width:100%; */
    max-width: 120px;
    max-height: 80px;
    /* height:24px; */
}

.bill_template .description_row{
  /* white-space: pre-line; */
  overflow-wrap: break-word;
}

.break_word{
  word-break: break-word;
}

.editable{
  border:1px dashed lightgray !important;
  position:relative;
}
.editabled-field-label{
  position: absolute;top: -15px;right: 0;padding: 0px 4px;background: #f0f0f0;font-size: 6px !important;
}
.bill_template.preview .editabled-field-label{
  font-size: 6px !important 
}
/* .preview .invoice_title{ */
.bill_template .invoice_title{
  /* font-size:16px !important; */
  font-size:20px !important;
}
.bill_template.font_small .invoice_title{
  font-size:16px !important;
}
.bill_template.font_large .invoice_title{
  font-size:24px !important;
  /* height: 28px !important; */
}
.bill_template.font_xl .invoice_title{
  font-size:26px !important;
  /* height: 32px !important; */
}
.bill_template.font_xxl .invoice_title{
  font-size:28px !important;
  /* height: 36px !important; */
}
.no-left-border{
  border-left:none;
}
.no-right-border{
  border-right:none !important;
}

.content_width_cols{
  width: 1%;
}

/* .preview.bill_template .business_logo{
  width: 48px;
  height: 48px;
} */

/* .bill_template .business_logo{
  display: inline-block;
  width: 48px;
  position: relative;
  height: 48px;
} */

.break_word{
  word-break:break-word
}

.page.receipt_template .business_logo img,
.bill_template .business_logo img{
  /* width: 100%;
  height: 100%; */
  max-width: 60px;
  max-height: 60px;
}

.bill_template .business_logo img.large_logo{
  max-width: 80px;
  max-height: 80px;
}

.bill_template .business_logo img.xl_logo{
  max-width: 100px;
  max-height: 100px;
}

.bill_template.print-settings .printnote-section{
    margin-top: 24px;
    margin-bottom: 16px;
    padding-bottom: 24px;
}

/* Gstr sub report */
table.gstr-sub-table{
    border-collapse: collapse !important;
}
.gstr-sub-table tr th,
.gstr-sub-table tr td{
    padding: 8px;
    min-width:120px;
    font-size:9px !important;
}
.gstr-sub-table thead{
    border-bottom: 1px solid #ddd;
}
/* ================== */

/* ===================== dialog sheet ================== */
.dialog_sheet_native .bottomsheet-search .v-input__slot,
.dialog_sheet .bottomsheet-search .v-input__slot{
  min-height: 42px !important;
	background-color: #F0F0F0 !important;
	border-radius: 0 !important;
	padding: 0px 16px !important;
}

.dialog_sheet_native .sticky-header,
.dialog_sheet .sticky-header{
	position: sticky;
	top: 0;
	z-index: 1;
	background: #fff !important;
}

.dialog_sheet.v-card{
	min-height: 75vh !important;
  max-height: 75vh !important;
  overflow: auto;
  scroll-behavior: smooth;
}

.native_sheet{
  max-width: 100%;
  min-height: 75vh;
  max-height: 75vh;
  border: 0;
  top: 25vh;
}

.native_sheet .sticky-header{
	position: sticky;
	top: 0;
	z-index: 1;
	background: #fff !important;
}

.native_dialog{
  /* max-width: 100%;
  min-height: 100%;
  max-height: 100%; */
  border: 0;
  margin: auto;
  border-radius: 5px;
}

.native_dialog.full-screen{
  max-width: 100%;
  min-height: 100%;
  max-height: 100%;
}

.native_dialog .v-toolbar{
  position: sticky;
  top: 0;
  z-index: 1;
}

.pending_invoice .v-icon{
  align-items: flex-start !important;
}

.drive_scope_image{
  background-image: url('/src/assets/google_permission.png');
}

dialog::backdrop {
  background-color: rgba(0,0,0,0.4);
}

.bill_template table { page-break-inside:auto }
.bill_template tr    { page-break-inside:avoid; page-break-after:auto }
.bill_template thead { display:table-header-group }
.bill_template tfoot { display:table-footer-group }

.two-btn-header{
  flex-direction: row;
  min-width: 128px;
}
/* ===================================================== */

.solo_dense_textbox .v-input__control{
  min-height: 32px !important;
}

.solo_dense_textbox .v-input__control .v-input__slot{
  padding: 0 6px !important;
}
/* ======================== batch layout ================== */
.batch_layout .flex{
  word-break: break-all;
  padding-right: 4px;
}

.batch_selected{
  background-color: #E5E4E2 !important;
}

/* ============= font family ================== */
@font-face {
    font-family: 'Hind-Regular';
    src: url('./assets/fonts/Hind-Regular.ttf');
}

#printable{
  background-color: #fff !important;
  /* width:210mm !important; */
}

#printdatatable.table_wrapper,
#printable .bill_template{
    font-family: 'Hind-Regular';
}

.bill_template{
    font-family: 'Hind-Regular';
    background-color: #fff !important;
}

/* #printable .bill_template table.items_table{
  table-layout: fixed;
}
#printable .bill_template table.items_table .content_width_cols{
  width: fit-content;
}
#printable .bill_template table.items_table tr td{
  overflow-wrap: break-word;
} */
/* ============ End of font css ================== */

.v-date-picker-table{
  height: 285px !important;
}

/* .bill_template.template_2 .hasLogo{
  float: right;
}
.preview.template_2 .business-details{
  float:left;
  min-width:100px;
  max-width:200px;
}
.bill_template.template_2 .business-details{
  float:left;
}
.bill_template.template_2 .business_logo{
  margin-left:8px;
} */

body *{
  -webkit-print-color-adjust: exact !important;
} 

#printable{
  display: none;
}

#printable-area{
  display: none;
}

#printable .remove-logo-btn{
  display: none !important;
}

#printable-area .remove-logo-btn{
  display: none !important;
}

@media print{
    .bill_template .upi-details-section .qr-code-container img{
        width: 64px;
    }
  #non-printable{display:none}
  #non-printable-area{display:none}
  /* #displayArea{display:none} */
  #printable{display: block !important;}
  #printable-area{display: block;}
  @page {
    margin: 0.5cm 1cm 0.5cm 1cm;
    /* size: A4; */
    /* margin: 10mm; */
  }

  /* hiding snackbar on print */
  .v-snack{
    display: none;
  }

  .fullpage.multi-page .spacer.border_all {
    border-left: 1px solid #000 !important;
    border-right: 1px solid #000 !important;
    border-top: 1px solid #000 !important;
    border-bottom: none !important; /* removes the extra line */
  }

  .fullpage.multi-page{
    border-bottom: 1px solid #000 !important;
  }

  .page.bom_template,
  .page.stock_transfer_template,
  .page.receipt_template{
    width: 210mm;
    height: 297mm;
    padding: 5mm;
  }
  .page.bom_template table,
  .page.stock_transfer_template table{
    height: 250mm;
  }
}

/* @page {
  margin: 0.5cm 1cm 0.5cm 1cm;
   @bottom-right {
    content: counter(page) " of " counter(pages);
   }
} */
 @page {
    margin: 0.5cm 1cm 0.5cm 1cm;
    /* size: A4; */
    /* margin: 10mm; */
  }

</style>


// WEBPACK FOOTER //
// src/App.vue